import { SearchVisits_trippy_searchVisits_visits_address } from '../graphql/athena/types/SearchVisits';

export const prettifyStreetAddress = (address: SearchVisits_trippy_searchVisits_visits_address) => {
  return `${address.street} ${address.unitType} ${address.unitNumber}`.trim();
};

export const prettifyCityStateZip = (address: SearchVisits_trippy_searchVisits_visits_address) => {
  return `${address.city}, ${address.state} ${address.postalCode}`.trim();
};

export const prettifyAddress = (addr: SearchVisits_trippy_searchVisits_visits_address) => {
  const street = `${addr.street} ${addr.unitType} ${addr.unitNumber}`.trim();
  return `${street}, ${addr.city}, ${addr.state} ${addr.postalCode}`;
};
